var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "url(#paint0_linear_1945_2096)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7117 12.8718C14.8324 15.6102 14.8324 18.3365 15.7092 21.0788C16.0634 21.0232 16.4027 20.9658 16.743 20.9182C16.956 20.8882 17.1722 20.8435 17.3842 20.8562C17.9902 20.8925 18.4249 21.2165 18.6204 21.8045C18.9193 22.7032 19.1973 23.6102 19.4474 24.5242C19.5838 25.0252 19.4519 25.4908 19.0864 25.8708C18.8162 26.1512 18.5554 26.4385 18.2096 26.6288C17.3878 27.0805 16.5569 27.1272 15.7027 26.7292C15.2606 26.5235 14.9251 26.1895 14.6262 25.8138C13.4918 24.3892 12.8331 22.7322 12.4305 20.9558C12.0168 19.1318 11.913 17.2848 12.0688 15.4205C12.1971 13.8795 12.5126 12.3831 13.0626 10.9425C13.4756 9.86081 14.0208 8.85781 14.7561 7.97148C15.3262 7.28415 16.0543 6.97315 16.9276 7.00181C17.5581 7.02281 18.1405 7.20015 18.6259 7.61748C18.9297 7.87881 19.2451 8.14681 19.3973 8.55015C19.5062 8.83848 19.5182 9.13348 19.4332 9.42615C19.1734 10.3195 18.9125 11.2125 18.6382 12.1008C18.4155 12.8215 17.7478 13.2225 17.0138 13.0975C16.6399 13.0335 16.2666 12.9658 15.893 12.9001C15.8384 12.8908 15.7838 12.8828 15.7117 12.8718Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1945_2096",
    x1: 8.25,
    y1: 52.3799,
    x2: 45.0098,
    y2: 23.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3191FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260918,
    stopColor: "#3191FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686166,
    stopColor: "#3191FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3191FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePhone);
export default __webpack_public_path__ + "static/media/circle-phone.ced49fb2ccc346c785ef583fe8060556.svg";
export { ForwardRef as ReactComponent };